export default __webpack_public_path__ + "static/media/payments.b046dcf3.png";